import HelpTooltip from './HelpTooltip';

export default function FieldHelp({ label, help, htmlFor, children }) {
  return (
    <div data-testid={`help-field-${htmlFor || 'unknown'}`}>
      <div className="flex items-center gap-1 mb-1">
        {label && <label htmlFor={htmlFor} className="text-xs text-[#64748B] font-medium">{label}</label>}
        {help && <HelpTooltip text={help} />}
      </div>
      {children}
    </div>
  );
}
